import Checkbox from 'components/Control/Checkbox'
import {useUrlParams} from 'services/hooks'
import {useI18n} from 'store/Store'
import {
    Container,
    Title,
} from 'components/Display/Table/TableTitleAndFilters/filtersStyles'
import {isChecked, toggleFilters} from 'services/utils/tableFilters'
import {genders} from 'constants/users'

const Gender = () => {
    const {i18n} = useI18n()
    const {urlParams, setUrlParam} = useUrlParams()

    const onChange = (fieldName) => (event) => {
        updateFiltersParams(fieldName, event.target.name)
    }

    const updateFiltersParams = (fieldName, value) => {
        const filters = urlParams[fieldName]?.split(',') || []
        const newFilters = toggleFilters(filters, value)
        setUrlParam(fieldName, newFilters)
    }

    return (
        <Container>
            <div>
                <Title>{i18n.t('users.gender')}</Title>
                {genders.map((gender) => (
                    <Checkbox
                        name={gender}
                        checked={isChecked(urlParams, 'gender', gender)}
                        onChange={onChange('gender')}
                        value={gender}
                        label={i18n.t(`users.genders.${gender}`)}
                    />
                ))}
            </div>
        </Container>
    )
}

export default Gender
